import axiosInstance from "../mainService";
const vehicleService = {
    getAllVehicles(search,page, limit) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get('/vehicle/' + sanitizedSearch + '/' + page + '/' + limit);
    },
    totalAllVehicles(search) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get('/vehicle-count/' + sanitizedSearch);
    }
}

export default vehicleService;